module.exports = __webpack_public_path__ + "img/XAI1.7679161c.jpg";